import { DesignType } from "../../../Interfaces/FundraiserRole";
import { dynamicCategoryDesignFetcher } from "../DynamicCategoryDesignFetcher";

export const getDesignCategories = (designs?: DesignType[]): string[] => {
  if (!designs) return [];

  const designCategories = dynamicCategoryDesignFetcher(designs);
  const result: string[] = [];
  const seen = new Set<string>();

  // First add categories with subcategories
  for (const [category, subcategories] of Object.entries(designCategories)) {
    if (subcategories.length > 0) {
      subcategories.forEach(sub => {
        const subLower = sub.toLowerCase();
        if (sub && subLower !== 'null' && subLower !== 'undefined' && !seen.has(subLower)) {
          seen.add(subLower);
          result.push(sub);
        }
      });
    } else if (category) {
      const categoryLower = category.toLowerCase();
      if (categoryLower !== 'null' && categoryLower !== 'undefined' && !seen.has(categoryLower)) {
        seen.add(categoryLower);
        result.push(category);
      }
    }
  }

  return result;
};

export type DesignCategory = string;
